<template>
    <div ref="accordionWrapper" :class="['accordion-wrapper', 'd-flex', 'flex-column', {'open': isOpen}, {'static-close': allowStaticClose}]" :style="[{'--grid-stretch-index': gridStretchIndex}]">
        <div class="accordion-header d-flex align-items-center justify-content-between" :style="[{'--backgroundColor-prop': backgroundColor}, {'--headerPadding': accordionHeaderPadding}]">
            <div class="left-wrapper d-flex text-start justify-content-between align-items-center w-100 pe-4 gap-2">
                <slot name="left">
    
                </slot>
                <slot name="middle">
    
                </slot>
            </div>
            <button v-if="isOpen">
                <img src="../assets/images/deleteButton.svg" alt="Close" class="close-button align-self-end" @click="triggerAccordion(), closeAccordionOnIndex()">
            </button>
            <button v-else class="blue-part-input light-text font-weight-500" @click="triggerAccordion(), openAccordionOnIndex()">
                <p>დეტალები</p>
            </button>
        </div>
        <div class="accordion-grid-body" :style="[{'--backgroundColor-prop': backgroundColor}]">
            <div class="accordion-body-content-wrapper">
                <slot name="additionalInfo">
    
                </slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            isOpen: false,
        }
    },
    props: {
        closeTrigger: {
            type: Boolean,
            default: false,
        },
        backgroundColor: {
            type: String,
            default: "#FFFFFF",
        },
        gridStretchIndex: {
            type: Number,
            default: 7,
        },
        allowStaticClose: {
            type: Boolean,
            default: false,
        },
        accordionHeaderPadding: {
            type: String,
            default: '23px',
        }
    },
    watch: {
        closeTrigger(){
            this.isOpen = false;
            // this.closeAccordionOnIndex();
        },
    },
    methods: {
        triggerAccordion(){
            this.isOpen = !this.isOpen;
        },
        closeAccordionOnIndex(){
            this.$emit("closeAccordionOnIndex");
        },
        openAccordionOnIndex(){
            this.$emit("openAccordionOnIndex");
        },
    }
}
</script>
<style scoped>
.accordion-wrapper{
    /* max-width: 570px; */
    width: 100%;
}
.accordion-wrapper.open{
    grid-row-start: 1;
    grid-row-end: var(--grid-stretch-index);
}
.accordion-header{
    padding: var(--headerPadding);
    background-color: var(--backgroundColor-prop);
    border-radius: 1em;
    transition: all 0.1s ease-out;
}
.accordion-wrapper.open .accordion-header{
    border-radius: 1em 1em 0 0;
    border-bottom: 2px solid var(--middle-blue);
}
.left-wrapper{
    align-items: start;
    column-gap: 2.5em;
}
.close-button{
    width: 30px;
    height: 30px;
}
.accordion-header .blue-part-input{
    padding: 8px 16px;
    border-radius: 1em;
    max-width: max-content
}

.accordion-grid-body{
    display: grid;
    grid-template-rows: 0fr;
    transition: all 0.2s ease-out;
}
.accordion-wrapper.open .accordion-grid-body {
    grid-template-rows: 1fr;
}
.accordion-body-content-wrapper{
    padding: 0 15px;
    margin: 0;
    background-color: var(--backgroundColor-prop);
    border-radius: 0 0 1em 1em;
    overflow: hidden;
    white-space: wrap;
    grid-row: 1 / span 2;
    transition: all 0.2s ease-out;
}
.accordion-wrapper.open .accordion-grid-body .accordion-body-content-wrapper {
    padding-block: 15px;
}
.accordion-wrapper.static-close :is(.accordion-header, .accordion-grid-body, .accordion-body-content-wrapper){
    transition: none;
}
/* .accordion-wrapper.open.static-close :is(.accordion-header, .accordion-grid-body, .accordion-body-content-wrapper){
    transition: all 0.1s ease-out;
} */
@media screen and (max-width: 1560px) {
    .accordion-header{
        padding: 15px;
        border-radius: 1em;
    }
    .left-wrapper{
        align-items: start;
        row-gap: 1em;
    }
    .accordion-header .blue-part-input{
        padding: 5px 10px;
        border-radius: 0.8em;
    }
    .accordion-body-content-wrapper{
        padding: 0 15px;
    }
    .accordion-wrapper.open .accordion-grid-body .accordion-body-content-wrapper {
        padding-block: 15px;
    }
}
</style>